// extracted by mini-css-extract-plugin
export var active = "_ve-1";
export var circle = "_ve-0";
export var completed = "_ve-2";
export var connector = "_ve-4";
export var connectorCompleted = "_ve-7";
export var connectorSpacer = "_ve-5";
export var iconStrokeOverride = "_ve-8";
export var labelContainer = "_ve-6";
export var pending = "_ve-3";